export default {
  view: 'client.view_client',
};
